import {ATLAS_DB, ATLAS_TMM_DB, REALTIME_DB} from '@/config/firebase';
import {ToastActionType} from '@/redux/slice/toastSlice';
import {push, ref, update} from 'firebase/database';

export interface INotification {
  id: string;
  type: ToastActionType;
  message: string;
  entity: any;
  createdAt: string;
  readAt?: null;
  firebaseKey?: string;
  title?: string;
  subtitle?: string;
  body?: string;
  thread?: string;
  timestamp: number;
}

export const addPilotNotification = (userId: string, data: any) => {
  const item = ref(REALTIME_DB, `${ATLAS_DB}/notifications/${userId}`);
  void push(item, {
    ...data,
    id: item.key
  });
};

export const getAllNotification = (airline: string) => {
  return ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/notifications`);
};

export const updateReadAtForManagerNotification = (
  airline: string,
  id: string
) => {
  const item = ref(
    REALTIME_DB,
    `${airline}/${ATLAS_TMM_DB}/notifications/${id}`
  );
  void update(item, {
    readAt: new Date().toISOString()
  });
};

export const addManagerNotification = async (
  airline: string,
  data: INotification
) => {
  const item = ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/notifications`);
  void push(item, {
    ...data
  });
};

export const managerNotification = (airline: string) => {
  return ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/notifications`);
};

export const userNotification = (userId: string) => {
  return ref(REALTIME_DB, `users/${userId}/notification`);
};
